export const pageWordKey = token => (token.normalized_form || token.surface_form || '').trim().toLowerCase();

// The rendered status is authoritative; older payloads may only carry user_state.
// Repeated occurrences and continuation fragments represent the same saved word.
export function getNewPageWords(tokens) {
  return [...new Set(tokens
    .filter(token => token.is_word && (token.status || token.user_state?.status || 'new') === 'new')
    .map(pageWordKey)
    .filter(Boolean))];
}

export function markWordsKnown(tokens, words) {
  const selected = new Set(words);
  return tokens.map(token => token.is_word && selected.has(pageWordKey(token)) ? {
    ...token, status: 'known', strength: 0.8, color: 'hsl(var(--foreground))',
    user_state: { ...token.user_state, status: 'known', strength: 0.8 },
  } : token);
}